import api from '@/lib/axios';
import type {
  EquipmentTypePublicReview,
  EquipmentTypeReviewsRequest,
  EquipmentTypeReviewSummary,
  ReservationReviewStatus,
  SubmitReservationReviewRequest,
  UpdateReservationReviewRequest,
  CustomerBookingReview,
} from '@/types/reviews';

export const submitReservationReview = async (
  request: SubmitReservationReviewRequest,
): Promise<CustomerBookingReview> => {
  const response = await api.post<CustomerBookingReview>('/customer/reviews', request);
  return response.data;
};

export const updateReservationReview = async (
  reservationId: string,
  request: UpdateReservationReviewRequest,
): Promise<CustomerBookingReview> => {
  const response = await api.put<CustomerBookingReview>(`/customer/reviews/${reservationId}`, request);
  return response.data;
};

export const getReservationReviewStatus = async (
  reservationId: string,
): Promise<ReservationReviewStatus> => {
  const response = await api.get<ReservationReviewStatus>(`/customer/reviews/reservation/${reservationId}`);
  return response.data;
};

export const getEquipmentTypeReviews = async (
  equipmentTypeId: string,
  params: EquipmentTypeReviewsRequest = {},
): Promise<EquipmentTypePublicReview[]> => {
  const response = await api.get<EquipmentTypePublicReview[]>(`/customer/equipment-types/${equipmentTypeId}/reviews`, {
    params: {
      sortBy: params.sortBy ?? 'newest',
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 20,
    },
  });

  return response.data;
};

export const getEquipmentTypeReviewSummary = async (
  equipmentTypeId: string,
): Promise<EquipmentTypeReviewSummary> => {
  const response = await api.get<EquipmentTypeReviewSummary>(`/customer/equipment-types/${equipmentTypeId}/review-summary`);
  return response.data;
};
